import { render, staticRenderFns } from "./BulkDomainDetails.vue?vue&type=template&id=8741470c&"
import script from "./BulkDomainDetails.vue?vue&type=script&lang=js&"
export * from "./BulkDomainDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports